import { SupportedTokenName } from "@mezo/sdk"
import {
  Block,
  LabelMedium,
  ListItem,
  ListItemLabel,
  ParagraphSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"

import {
  selectTokenBalance,
  selectTokenDecimals,
  useDappSelector,
} from "#/redux-state"
import {
  getCurrencySymbol,
  getMezoTokenName,
  getTokenIcon,
} from "#/shared/utils"

import OverviewTokenUsdValue from "./OverviewTokenUsdValue"
import OverviewTokenValue from "./OverviewTokenValue"

type OverviewBridgedAssetsItemProps = {
  token: SupportedTokenName
  isLoading?: boolean
}

export default function OverviewBridgedAssetsItem({
  token,
  isLoading,
}: OverviewBridgedAssetsItemProps) {
  const tokenBalance = useDappSelector((state) =>
    selectTokenBalance(state, token),
  )

  const tokenDecimals = useDappSelector((state) =>
    selectTokenDecimals(state, token),
  )

  const [css, theme] = useStyletron()

  // No need to show tokens which do not have any balance
  if (!isLoading && tokenBalance === 0n) return null

  return (
    <ListItem
      state={isLoading ? "loading" : "enabled"}
      overrides={{
        ArtworkContainer: {
          style: () => ({ width: "80px", height: "80px" }),
        },
        Content: { style: () => ({ borderBottom: "none" }) },
        Root: {
          style: () => ({
            borderBottom: `1px solid ${theme.colors.borderOpaque}`,
          }),
        },
      }}
      artwork={() => (
        <Block as="img" src={getTokenIcon(token)} width="48px" height="48px" />
      )}
      endEnhancer={() => (
        <Block className={css({ textAlign: "right" })}>
          <LabelMedium>
            <OverviewTokenUsdValue
              amount={tokenBalance}
              token={token}
              decimals={Number(tokenDecimals)}
            />
          </LabelMedium>
          <ParagraphSmall color={theme.colors.contentSecondary}>
            <OverviewTokenValue
              amount={tokenBalance}
              token={token}
              decimals={Number(tokenDecimals)}
            />
          </ParagraphSmall>
        </Block>
      )}
    >
      <ListItemLabel description={getCurrencySymbol(token)}>
        {getMezoTokenName(token) ?? ""}
      </ListItemLabel>
    </ListItem>
  )
}
